import styled from 'styled-components'
import { media } from '../../theme/breakpoints'

export const HomeContent = styled.div`
    width: 100%;
    height: 100%;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;

    ${media.tabletAndAbove} {
        padding-left: 40px;
        padding-right: 40px;
    }

    ${media.desktop} {
        padding-left: 20px;
        padding-right: 20px;
    }
`
